import { RESOURCES_BASE } from './constants'

export interface InsidePage {
  src: string
  alt: string
}

/** Five interior pages of the product. */
export const insidePages: InsidePage[] = [
  { src: RESOURCES_BASE + '1793872106003_page1-m2-potassium-3bb13cb9.jpg', alt: 'Module 02 · Potassium (K) : fiche atlas' },
  { src: RESOURCES_BASE + '1793872112613_page2-m1-racine-312b04e5.jpg', alt: 'Module 01 · Système racinaire et zones d’absorption' },
  { src: RESOURCES_BASE + '1793872118645_page3-m3-compaction-be5db9d0.jpg', alt: 'Module 03 · Arbre de décision : tassement du sol' },
  { src: RESOURCES_BASE + '1793872126045_page4-m4-observer-e027fee1.jpg', alt: 'Module 04 · Observer la parcelle, échelle par échelle' },
  { src: RESOURCES_BASE + '1793872131538_page5-m6-fiche-d5127b01.jpg', alt: 'Module 06 · Fiche de diagnostic imprimable' },
]
